import "./TechnicalNotes.module.css";
import Navigation from "@/reusable_sections/Header";
import DarkroomInsights from "./sections/DarkroomInsights";
import EnthusiastNewsletter from "./sections/EnthusiastNewsletter";
import FooterArchive from "@/reusable_sections/Footer";
export default function TechnicalNotesPage() {
  return <div>
      <Navigation />
      <DarkroomInsights />
      <EnthusiastNewsletter />
      <FooterArchive />
    </div>;
}